var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/expert-badge.tsx";
import "core-js/modules/es.array.includes.js";
import classNames from 'clsx';
import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import Icon from 'soapbox/components/ui/icon/icon';
const messages = defineMessages({
  expert: {
    "id": "account.expert",
    "defaultMessage": "Expert Account"
  }
});

const ExpertBadge = _ref => {
  let {
    className,
    badges
  } = _ref;
  const intl = useIntl(); // Prefer a custom icon if found

  const icon = require('assets/icons/expert.svg'); // Render component based on file extension


  const Element = icon.endsWith('.svg') ? Icon : 'img';

  if (!badges.includes("badge:expert")) {
    return null;
  }

  return /*#__PURE__*/React.createElement("span", {
    className: "expert-icon",
    "data-testid": "expert-badge",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Element, {
    className: classNames('w-4 text-accent-500', className),
    src: icon,
    alt: intl.formatMessage(messages.expert),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 7
    }
  }));
};

export default ExpertBadge;